var _defs, _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyanimelist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "myanimelist_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".myanimelist_svg__cls-2{fill:#fff}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 22.64,
    fill: "#395db0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "myanimelist_svg___52g2ce_tif",
    "data-name": "52g2ce.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "myanimelist_svg__cls-2",
    d: "M73.05 64.08v62.69H56.64V88.31L41.37 106 27.24 88.64v38.43H10.51v-63H27.07l14.17 20 15.25-20zM135.58 64.08c1.36 4.42 2.71 8.84 4.21 13.7H118.85c-9.81 0-15.14 4.91-16.22 15.22H119V79.84H137.1v47H119.26V106.38H98.12l7.17 21.15-12.1 8.39A107.57 107.57 0 0183.07 106a38.65 38.65 0 011.56-20.91C89.35 72.54 99 64.88 112.13 65M166.85 64.08v49.11h22.64l-3.58 13.72H150.3V64.08z"
  }))));
}

export default SvgMyanimelist;